// removed by extract-text-webpack-plugin
module.exports = {"compose-message":"compose-message","compose-conversation":"compose-conversation","compose":"compose","compose-message-toolbar":"compose-message-toolbar","ButtonGroup__root___3lEAn":"ButtonGroup__root___3lEAn","ButtonWrap__root___1EO_R":"ButtonWrap__root___1EO_R","IconButton__isActive___2Ey8p":"IconButton__isActive___2Ey8p","compose-message-textarea":"compose-message-textarea","DraftEditor-root":"DraftEditor-root","DraftEditor-editorContainer":"DraftEditor-editorContainer","notranslate":"notranslate","public-DraftEditor-content":"public-DraftEditor-content"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ComposeMessage/ComposeMessage.scss
// module id = 4958
// module chunks = 1